/**
 * Created by Astha on 10/8/2018.
 */
//@flow

export default class DownloadPageParams {
  _type: string;
  _displayName: string;
  _collectionName: string;
  _jobId: string;

  constructor(type: string, displayName: string, collectionName: string, jobId: string) {
    this._type = type;
    this._displayName = displayName;
    this._collectionName = collectionName;
    this._jobId = jobId;
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get displayName(): string {
    return this._displayName;
  }

  set displayName(value: string) {
    this._displayName = value;
  }

  get collectionName(): string {
    return this._collectionName;
  }

  set collectionName(value: string) {
    this._collectionName = value;
  }

  get jobId(): string {
    return this._jobId;
  }

  set jobId(value: string) {
    this._jobId = value;
  }

}